import apiService from './apiService';

/**
 * NIC Trip Sync API
 * GET /api/v1/trips/{trip_id}/nic-vlts-sync
 * @param {string} tripId - UUID of the trip
 */
export const getTripNicSync = async (tripId) => {
  if (!tripId) {
    throw new Error('Trip ID is required');
  }
  try {
    return await apiService.get(`/api/v1/trips/${tripId}/nic-vlts-sync`);
  } catch (error) {
    // 404 
    if (error?.message?.includes('404')) {
      return { data: [] };
    }
    throw error;
  }
};

export default {
  getTripNicSync,
};
